import { render, staticRenderFns } from "./ThemeProvider.vue?vue&type=template&id=7a070dda"
import script from "./ThemeProvider.vue?vue&type=script&lang=js"
export * from "./ThemeProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a070dda')) {
      api.createRecord('7a070dda', component.options)
    } else {
      api.reload('7a070dda', component.options)
    }
    module.hot.accept("./ThemeProvider.vue?vue&type=template&id=7a070dda", function () {
      api.rerender('7a070dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ThemeProvider.vue"
export default component.exports